'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reactRouterRedux = require('react-router-redux');

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _Login = require('../../helpers/Login');

var _Login2 = _interopRequireDefault(_Login);

var _Provider = require('../../helpers/Provider');

var _SessionStorage = require('../../helpers/SessionStorage');

var _AuthorizationSSOSuccess = require('./AuthorizationSSOSuccess.scss');

var _AuthorizationSSOSuccess2 = _interopRequireDefault(_AuthorizationSSOSuccess);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthorizationSSOSuccess = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth, appInfo: state.appInfo, log: state.log };
}, { pushState: _reactRouterRedux.push }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(AuthorizationSSOSuccess, _Component);

  function AuthorizationSSOSuccess() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, AuthorizationSSOSuccess);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AuthorizationSSOSuccess.__proto__ || (0, _getPrototypeOf2.default)(AuthorizationSSOSuccess)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      loading: false,
      provider: null
    }, _this.onStartMusic = function () {
      _this.setState({ loading: true });
      (0, _Login2.default)(_this.props.auth.sessionId, _this.props.auth, _this.props.log, _this.props.appInfo, _this.props.pushState);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(AuthorizationSSOSuccess, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var provider = (0, _Provider.getProviderFromStorage)(_SessionStorage.SessionStorageKeys.SelectedProviderKey);
      this.setState({ provider: provider });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var providerName = this.state.provider ? this.state.provider.name : '';
      return _react2.default.createElement(
        'div',
        { className: _AuthorizationSSOSuccess2.default.authorizationSSOSuccess },
        _react2.default.createElement(
          'div',
          { className: _AuthorizationSSOSuccess2.default.title },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Authorization)
        ),
        _react2.default.createElement(_components.ProviderLogo, { className: _AuthorizationSSOSuccess2.default.providerLogo, provider: this.state.provider }),
        _react2.default.createElement(
          'div',
          { className: _AuthorizationSSOSuccess2.default.congrat },
          _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations.Congratulations)
        ),
        _react2.default.createElement(
          'div',
          { className: _AuthorizationSSOSuccess2.default.message },
          _react2.default.createElement(_reactIntl.FormattedHTMLMessage, (0, _extends3.default)({}, _DefaultString.translations.AuthorizationSSOSuccessMessage, {
            values: { provider: providerName }
          }))
        ),
        _react2.default.createElement(_components.BaseButton, { onClick: function onClick() {
            return _this2.onStartMusic();
          }, buttonString: _DefaultString.translations.StartStingrayMusic, loading: this.state.loading })
      );
    }
  }]);
  return AuthorizationSSOSuccess;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  appInfo: _react.PropTypes.object,
  log: _react.PropTypes.object,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = (0, _reactIntl.injectIntl)(AuthorizationSSOSuccess);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/AuthorizationSSOSuccess/AuthorizationSSOSuccess.js
// module id = 1999
// module chunks = 0